// The "Shared with Patient" quick inserts on a psychology note unlock only once
// the clinician has written something of their own about this session, so the
// Visit Summary isn't just boilerplate. Lines added by the quick inserts don't
// count towards that.
export const QUICK_INSERT_PREFIXES = ["• Sleep Hygiene:", "• Anxiety Management:", "• Homework:", "• Things to Avoid:"];
export const MIN_OWN_SUMMARY_CHARS = 30;

export function ownSummaryText(text) {
  return (text || "")
    .split("\n")
    .filter((line) => !QUICK_INSERT_PREFIXES.some((p) => line.trim().startsWith(p)))
    .join(" ")
    .trim();
}
